import type { PropsWithChildren } from 'react';
import React from 'react';
import type { DropAnimation } from '@dnd-kit/core';
import { DragOverlay } from '@dnd-kit/core';

interface Props {
  adjustScale?: boolean;
  /** Omit for dnd-kit's default drop animation; `null` drops instantly. */
  dropAnimation?: DropAnimation | null;
  /** Merged over the overlay's own positioning styles — dnd-kit spreads it last, so it wins. */
  style?: React.CSSProperties;
}

export function SortableOverlay({ children, adjustScale = true, dropAnimation, style }: PropsWithChildren<Props>) {
  return (
    <DragOverlay
      adjustScale={adjustScale}
      dropAnimation={dropAnimation}
      style={style}
    >
      {children}
    </DragOverlay>
  );
}
